module.exports = __webpack_public_path__ + "assets/img/image preview.00484e8b.gif";